import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export const useMutationDeleteSessionPack = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ sessionPackId }: { sessionPackId: number }) => {
      await api.creditPackApi.delete(sessionPackId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionPackQueryKeys.all() });
    },
  });
  return mutation;
};
